<app-modal [header]="'orderChoice.configuration-consistent_sample.title' | translate">
  @if (!showSuccessPage()) {
    <div modal-body class="configuration-consistent-samples-content">
      <div class="py-4">
        {{ 'orderChoice.configuration-consistent_sample.message' | translate:{'0': project?.name} }}
      </div>
      <div class="pt-4 pb-2">
        {{ 'orderChoice.configuration-consistent_sample.needed_information' | translate }}
      </div>
      <div formValidator (formValid)="formValid.set($event)" class="border p-4 form-section">
        <form class="d-flex flex-column gap-5">
          <div class="d-flex flex-wrap gap-5">
            <div class="d-flex flex-column flex-grow-1 gap-5">
              <div class="d-flex flex-column gap-2">
                <div class="form-group">
                  <label for="salutation">{{ 'orderChoice.configuration-consistent_sample.label.salutation' | translate }}</label>
                  <select
                    id="salutation"
                    name="salutation"
                    class="form-control"
                    [(ngModel)]="model().salutation"
                    maxlength="100"
                    [validator]="validators.salutation"
                  >
                    <option>{{ 'orderChoice.configuration-consistent_sample.annotation.male' | translate }}</option>
                    <option>{{ 'orderChoice.configuration-consistent_sample.annotation.female' | translate }}</option>
                    <option>{{ 'orderChoice.configuration-consistent_sample.annotation.divers' | translate }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="first-name">{{ 'orderChoice.configuration-consistent_sample.label.first_name' | translate }} *</label>
                  <input
                    id="first-name"
                    class="form-control"
                    name="first-name" type="text"
                    [(ngModel)]="model().firstName"
                    maxlength="100"
                    [validator]="validators.firstName"
                  />
                </div>
                <div class="form-group">
                  <label for="last-name">{{ 'orderChoice.configuration-consistent_sample.label.last_name' | translate }} *</label>
                  <input
                    id="last-name"
                    class="form-control"
                    name="last-name"
                    type="text"
                    [(ngModel)]="model().lastName"
                    maxlength="100"
                    [validator]="validators.lastName"
                  />
                </div>
                <div class="form-group">
                  <label for="email">{{ 'orderChoice.configuration-consistent_sample.label.email' | translate }} *</label>
                  <input
                    id="email"
                    class="form-control"
                    name="email" type="email"
                    [(ngModel)]="model().emailAddress"
                    maxlength="254"
                    [validator]="validators.emailAddress"
                  />
                </div>
                <div class="form-group">
                  <label for="phone">{{ 'orderChoice.configuration-consistent_sample.label.phone' | translate }}</label>
                  <input
                    id="phone"
                    class="form-control"
                    name="phone"
                    type="text"
                    [(ngModel)]="model().phoneNumber"
                    maxlength="100"
                    [validator]="validators.phoneNumber"
                  />
                </div>
              </div>
            </div>
            <div class="d-flex flex-column flex-grow-1 gap-5">
              <div class="d-flex flex-column gap-2 flex-wrap">
                <div class="d-flex gap-2 flex-wrap">
                  <div class="form-group flex-grow-1">
                    <label for="street">{{ 'orderChoice.configuration-consistent_sample.label.street' | translate }} *</label>
                    <input
                      id="street"
                      class="form-control"
                      name="street"
                      type="text"
                      [(ngModel)]="model().street"
                      maxlength="100"
                      [validator]="validators.street"
                    />
                  </div>
                  <div class="form-group">
                    <label for="house-number">{{ 'orderChoice.configuration-consistent_sample.label.house_number' | translate }} *</label>
                    <input
                      id="house-number"
                      class="form-control"
                      name="house-number"
                      type="text"
                      [(ngModel)]="model().houseNumber"
                      maxlength="10"
                      [validator]="validators.houseNumber"
                    />
                  </div>
                </div>
                <div class="d-flex gap-2 flex-wrap">
                  <div class="form-group">
                    <label for="zip-code">{{ 'orderChoice.configuration-consistent_sample.label.zip_code' | translate }} *</label>
                    <input
                      id="zip-code"
                      class="form-control"
                      name="zip-code"
                      type="text"
                      [(ngModel)]="model().zipCode"
                      maxlength="10"
                      [validator]="validators.zipCode"
                    />
                  </div>
                  <div class="form-group flex-grow-1">
                    <label for="city">{{ 'orderChoice.configuration-consistent_sample.label.city' | translate }} *</label>
                    <input
                      id="city"
                      class="form-control"
                      name="city"
                      type="text"
                      [(ngModel)]="model().city"
                      maxlength="100"
                      [validator]="validators.city"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label for="city">{{ 'orderChoice.configuration-consistent_sample.label.country' | translate }} *</label>
                  <input
                    id="country"
                    class="form-control"
                    name="country" type="text"
                    [(ngModel)]="model().country"
                    maxlength="100"
                    [validator]="validators.country"
                  />
                </div>
                <div class="form-group">
                  <label for="customer-no">{{ 'orderChoice.configuration-consistent_sample.label.customer_no' | translate }}</label>
                  <input
                    id="customer-no"
                    class="form-control"
                    name="customer-no"
                    type="text"
                    [(ngModel)]="model().customerNumber"
                    maxlength="100"
                    [validator]="validators.customerNumber"
                  />
                </div>
                <div class="d-flex gap-2 flex-wrap">
                  <div class="form-group flex-grow-1">
                    <label for="company">{{ 'orderChoice.configuration-consistent_sample.label.company' | translate }} *</label>
                    <input
                      id="company"
                      class="form-control"
                      name="company"
                      type="text"
                      [(ngModel)]="model().company"
                      maxlength="100"
                      [validator]="validators.company"
                    />
                  </div>
                  <div class="form-group flex-grow-1">
                    <label for="department">{{ 'orderChoice.configuration-consistent_sample.label.department' | translate }}</label>
                    <input
                      id="department"
                      class="form-control"
                      name="department"
                      type="text"
                      [(ngModel)]="model().department"
                      maxlength="100"
                      [validator]="validators.department"
                    />
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="d-flex gap-3 flex-wrap">
            <div class="d-flex flex-column gap-2">
              <div class="form-group">
                <label for="amount">{{ 'orderChoice.configuration-consistent_sample.label.amount' | translate }} *</label>
                <input
                  id="amount"
                  class="form-control"
                  name="amount"
                  type="text"
                  [(ngModel)]="model().amount"
                  inputRestricter="^[0-9\.,]*$"
                  maxlength="100"
                  [validator]="validators.amount"
                />
              </div>
              <div class="form-group">
                <label for="estimatedAnnualDemand">
                  {{ 'orderChoice.configuration-consistent_sample.label.estimated_annual_demand' | translate }} *
                </label>
                <input
                  id="estimatedAnnualDemand"
                  class="form-control"
                  name="estimatedAnnualDemand"
                  type="text" [(ngModel)]="model().estimatedAnnualDemand"
                  inputRestricter="^[0-9\.,]*$"
                  maxlength="100"
                  [validator]="validators.estimatedAnnualDemand"
                />
              </div>
            </div>
            <div class="form-group flex-grow-1">
              <label for="applicationDescription">
                {{ 'orderChoice.configuration-consistent_sample.label.application_description' | translate }} *
              </label>
              <textarea
                id="applicationDescription"
                class="form-control"
                name="applicationDescription"
                style="height: 100px"
                [(ngModel)]="model().applicationDescription"
                [validator]="validators.applicationDescription"
              ></textarea>
            </div>
          </div>
        </form>
      </div>
    </div>
  } @else {
    <div modal-body class="configuration-consistent-samples-thanks">
      <app-project-order-thanks [model]="{requestSucceeded: orderedSuccessfully}" [orderedDirectly]="true"/>
    </div>
  }
  <ng-container modal-footer>
    <button class="btn btn-secondary btn-cancel" type="button" (click)="cancel()">{{ (showSuccessPage() ? 'global.label.close' :  'global.label.cancel') | translate }}</button>
    @if (!showSuccessPage()) {
      @if (false) {
        <!-- The back button is not needed while opening from the menu, but will be, when the rest of the new order process gets merged -->
        <button class="btn btn-secondary btn-back" type="button" (click)="back()">{{ 'global.label.back' | translate }}</button>
      }
      <button
        class="btn btn-secondary btn-back"
        type="button"
        (click)="contactSales()"
      >
        {{ 'orderChoice.title.configurations.contact_sales' | translate }}
      </button>
      <button
        class="btn btn-primary btn-forward"
        type="button"
        (click)="sendSampleRequest()"
        [disabled]="!formValid()"
        appActionLogId="configurationConsistentSampleRequest.sendRequest"
      >
        {{ 'orderChoice.configuration-consistent_sample.button.send_request' | translate }}
      </button>
    }
  </ng-container>
</app-modal>
